function noop(..._) { }

export { noop };
